import { render, staticRenderFns } from "./the-check-dialog.vue?vue&type=template&id=6cd0f2ae&"
import script from "./the-check-dialog.vue?vue&type=script&lang=js&"
export * from "./the-check-dialog.vue?vue&type=script&lang=js&"
import style0 from "./the-check-dialog.vue?vue&type=style&index=0&id=6cd0f2ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports